/* AF site - shared reviews (real texts from live registracija + kainorastis pages). Rendered into [data-site-reviews] by site.js. */
window.AF_REVIEWS = {
 "heading": "Ką sako mūsų klientai",
 "overall": "★★★★★ 5.0 · tūkstančiai įvertinimų",
 "items": [
  {
   "img": "site/img/reg/1.1_raimonduxs.jpg",
   "text": "Susibūrėm visa kompanija ir pasidarėm kartu — geriausias sprendimas! Dabar ant sienos kabo dalelė kiekvieno iš mūsų 🙌",
   "author": "Tomas S.",
   "initials": "TS"
  },
  {
   "img": "site/img/af-e8cbc730-93b.webp",
   "title": "Jau seniai buvau taip maloniai ir šiltai aptarnauta",
   "text": "Labai įsimintina patirtis - nuo priėmimo, nuotraukų darymo iki galutinio rezultato :) šaunuoliai, tęskit ką darot!"
  },
  {
   "img": "site/img/reg/17.1_lysia_a1.jpg",
   "text": "Nustebinom vienas kitą ir patys nesitikėjom, kad taip sujaudins 💖 Dvi akys greta — tiesiog tobula.",
   "author": "Kristina I.",
   "initials": "KI"
  },
  {
   "img": "site/img/af-feb07515-2a8.webp",
   "title": "Kantrūs su vaikais, viskas puikiai pavyko",
   "text": "Vyro svajonė buvo turėti šeimos akių nuotraukas. Padovanojau kuponą gimtadienio proga. Esam labai patenkinti rezultatu. Gavom labai greitai."
  },
  {
   "img": "site/img/reg/4.1_norvaisaite.jpg",
   "text": "Geriausia dovana sau pačiai 🙂 Niekada nebūčiau pagalvojusi, kad sava akis gali atrodyti taip gražiai.",
   "author": "Paulina K.",
   "initials": "PK"
  },
  {
   "img": "site/img/af-a18e5645-bf3.webp",
   "title": "Nustebau nuo nuotraukų..",
   "text": "Nuostabi patirtis, kažkas WOW matyti tokias savo unikalias nuotraukas :) Labai labai patiko, personalas fantastinis :) Rekomenduojam 10/10!"
  },
  {
   "img": "site/img/reg/6.itsbrigitta_3.jpg",
   "text": "Svečiai visada sustoja ir klausia „kur tokį radot?\" 😄 Interjeras iškart kitoks.",
   "author": "Laurita P.",
   "initials": "LP"
  },
  {
   "img": "site/img/af-aaca8b13-649.webp",
   "title": "Labai malonus kolektyvas",
   "text": "Labai mandagūs, geros nuotaikos, savo sferos specialistai. Nuoširdžiai rekomenduoju, tikrai patars, turėsite gerą laiką bei atsiminimą."
  },
  {
   "img": "site/img/reg/18.1_rugiliepa1.jpg",
   "text": "Užsisakėm dviese metinių proga. Spalvos visiškai skirtingos — kaip ir mūsų charakteriai 😅 o kartu dera idealiai.",
   "author": "Justė R.",
   "initials": "JR"
  },
  {
   "img": "site/img/af-b7b14352-2e1.webp",
   "title": "Rezultatas džiugina, tikrai verta!",
   "text": "Fotografuotis buvo lengva, linksma ir malonu. Maloniai bendraujantis fotografas ir jauki atmosfera. Esame labai patenkinti rezultatu.."
  },
  {
   "img": "site/img/reg/13.3_Karolina_Zozulyte3.jpg",
   "text": "Vis dar negaliu patikėti, kad tai TIKRAI mano akis 🤯 Detalės nerealios. Rekomenduoju visiems!",
   "author": "Karolina Z.",
   "initials": "KZ"
  },
  {
   "img": "site/img/af-cc02d42c-e33.webp",
   "title": "Šiltas bendravimas",
   "text": "Labai malonus bendravimas ne tik nuvykus į studija, bet ir poto. Nuotrauką gavau jau po 2 dienų."
  },
  {
   "img": "site/img/reg/9.3_evaiieva.jpg",
   "text": "Iš pradžių planavau kaip dovaną mylimajam, o dabar džiaugiamės abu kasdien ❤️",
   "author": "Monika G.",
   "initials": "MG"
  },
  {
   "img": "site/img/af-db238d61-e64.webp",
   "title": "Malonus ir profesionalus aptarnavimas",
   "text": "Fotografuojant atsižvelgė į kiekvieną detalę, o pats procesas užtrunka vos kelias minutes. Rekomenduoju išbandyti!"
  },
  {
   "img": "site/img/reg/2_karolina.a.m.jpg",
   "text": "Kabo svetainėje ir kiekvieną rytą juo gėriuosi. Mano ir vyro mažas ženklas namuose.",
   "author": "Aurelija V.",
   "initials": "AV"
  },
  {
   "img": "site/img/af-4d655e7f-263.webp",
   "title": "Labai gražus paveikslas",
   "text": "Šis paveikslas mums primena, kokie mes unikalūs. Visi, kas pamato ją pas mus namuose, negali atitraukti akių!"
  },
  {
   "img": "site/img/reg/1.1_Urbonaviciutte.jpg",
   "text": "Pasidovanojom patys sau 😌 Du tokie skirtingi žvilgsniai, o kartu — tobula pora.",
   "author": "Rūta U.",
   "initials": "RU"
  },
  {
   "img": "site/img/af-af45fe63-433.webp",
   "title": "Esu labai patenkintas!",
   "text": "Pirkau dovanų kuponą savo žmonai ir ji liko labai patenkinta šia dovana.. Svečiai spėliojo kas iš viso čia yra! :)"
  },
  {
   "img": "site/img/reg/14.2_ktrbkk2.jpg",
   "text": "Visa šeima viename — penkios akys ant sienos! 😍 Kiekvieno rainelė kitokia, kartu kaip muziejaus eksponatas.",
   "author": "Kotryna B.",
   "initials": "KB"
  },
  {
   "img": "site/img/af-ba9f7287-eeb.webp",
   "title": "Operatyvus ir kokybiškas darbas",
   "text": "Antradienį vakare nufotografavo, ketvirtadienį jau turėjau paruoštą nuotrauką. Rekomenduoju visiems išbandyti šią patirtį!"
  },
  {
   "img": "site/img/reg/15.2_Kudzyte2.jpg",
   "text": "Pati fotosesija užtruko vos kelias minutes ir buvo labai jauku. O rezultatas pranoko visus lūkesčius 🙌",
   "author": "Eglė K.",
   "initials": "EK"
  },
  {
   "img": "site/img/af-87da38c9-513.webp",
   "title": "Labai įdomi paslauga",
   "text": "Apsilankymas vyko labai sklandžiai ir greitai bei maloniai. Nuotraukos, dėkliukas puikus! Dėkoju!"
  },
  {
   "img": "site/img/reg/2.1_Meda_Sadlauskaite.jpg",
   "text": "Valentino dienai — vienas kitam 💕 Gražesnio mūsų istorijos simbolio sunku ir sugalvoti.",
   "author": "Meda S.",
   "initials": "MS"
  },
  {
   "img": "site/img/af-8cc55a93-51d.webp",
   "title": "Labai mums patiko!",
   "text": "Gavome su vyru dovanų kuponą.. Net nesitikėjome, kad procesas bus toks įdomus ir smagus!"
  },
  {
   "img": "site/img/reg/22.2_sandzil2.jpg",
   "text": "Sau gimtadienio proga 🎂 Tiek gylio ir spalvų viename mažame rate — negaliu atsižiūrėti.",
   "author": "Sandra Ž.",
   "initials": "SŽ"
  },
  {
   "img": "site/img/af-bc94f2c3-411.webp",
   "title": "Greitas aptarnavimas",
   "text": "Labai patiko galutinis rezultatas, o dar labiau patiko greitas aptarnavimas. Buvome su naujagimiu, užtrukome 2 žmones nufotografuoti vos keletą minučių"
  },
  {
   "img": "site/img/reg/3.1_Zebliauskaite.jpg",
   "text": "Pasirinkau kosminį efektą ir... wow 🌌 Mano akis kaip visa galaktika.",
   "author": "Marta Ž.",
   "initials": "MŽ"
  },
  {
   "img": "site/img/af-2b1d4f7b-c4d.webp",
   "title": "Tiesiog WOOW!",
   "text": "Niekada nebūtume pagalvoję, kad taip gali atrodyti mūsų šeimos akys. Papuošėme savo namus unikaliu ir neįprastu paveiksu :)"
  },
  {
   "img": "site/img/reg/6.1_boozhena1.jpg",
   "text": "Pakabinom miegamajame virš lovos — pirmas vaizdas rytais, ir kaskart nusišypsom 😊",
   "author": "Božena B.",
   "initials": "BB"
  },
  {
   "img": "site/img/af-3cacb6ad-2a2.webp",
   "title": "Jūs geriausi, ačiū!",
   "text": "Bendravimas labai šiltas, moka elgtis su vaikais - tas labai patiko :).. Ačiū, ir rezultatas puikus!"
  }
 ]
};
